import { render, staticRenderFns } from "./BreadcrumbName.vue?vue&type=template&id=30f155cf&scoped=true"
import script from "./BreadcrumbName.vue?vue&type=script&setup=true&lang=ts"
export * from "./BreadcrumbName.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BreadcrumbName.vue?vue&type=style&index=0&id=30f155cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f155cf",
  null
  
)

export default component.exports